import { ErrorInRoute } from "@core/presentation/components/routing/error-in-route/error-in-route.component.tsx";
import { Route } from "react-router";

const NOTEBOOK_PARAM = ":id?";
const NOTEBOOK_PATH = "/notebook";
const NOTEBOOK_WITH_STATION = `${NOTEBOOK_PATH}/${NOTEBOOK_PARAM}`;

export const NotebookRoutes = {
    NotebookParam: NOTEBOOK_PARAM,
    NotebookWithStation: NOTEBOOK_WITH_STATION,
    Notebook: NOTEBOOK_PATH,

    NOTEBOOK: (id?: string): string =>
        id ? NOTEBOOK_WITH_STATION.replace(NOTEBOOK_PARAM, id) : NOTEBOOK_PATH,
} as const;

export const notebookRoutes = (
    <Route
        path={`${NotebookRoutes.Notebook}/${NotebookRoutes.NotebookParam}`}
        errorElement={<ErrorInRoute />}
        lazy={async () => {
            const { NotebookModuleLayout } =
                await import("@notebook/presentation/layout/notebook-module.layout.tsx");
            return { Component: NotebookModuleLayout };
        }}
    >
        <Route
            index
            lazy={async () => {
                const { NotebookPage } =
                    await import("@notebook/presentation/pages/notebook/notebook.page");
                return { Component: NotebookPage };
            }}
        />
    </Route>
);
